import React from 'react';
import { Heading } from 'paypo-ui/components';

import Section from '../../layout/Section';
import NumberList from './NumberList';

const SectionDataInNumbers = ({
    config = {},
    background,
    dataFromApi,
    paddingSmall = false,
}) => {
    const { numbersData, title } = config;

    return (
        <Section
            background={ background }
        >
            {
                title && 
                    <Heading>
                        { title }
                    </Heading>
            }

            {
                ( numbersData || dataFromApi ) && (
                    <NumberList
                        paddingSmall={ paddingSmall }
                        listData={ numbersData || dataFromApi }
                    />
                )
            }
        </Section>
    );
};

export default SectionDataInNumbers;
